// File: @/config/constants.ts

/**
 * Feature flags for build-time configuration
 */
export const FEATURE_FLAGS = {
  /**
   * Enable production source maps for debugging
   * Recommended: true for better error tracking
   * Impact: Slightly larger bundle size, better error tracking
   */
  PRODUCTION_SOURCE_MAPS: true,

  /**
   * Remove console.* calls in production builds
   * DISABLED: Rely on ESLint enforcement instead of build-time removal
   * This preserves logger service console output in production while ESLint prevents direct console usage
   */
  REMOVE_CONSOLE_LOGS: false,

  /**
   * Enable trailing slashes on URLs
   * Set to false for consistency with existing Next.js routes
   */
  TRAILING_SLASH: false,
} as const;

/**
 * Environment detection helpers
 * Used throughout configuration modules for conditional logic
 */
export const ENV = {
  isDevelopment: process.env['NODE_ENV'] === 'development',

  /**
   * Enables verbose analytics debug telemetry in non-production analytics mode.
   *
   * Usage:
   * - Set NEXT_PUBLIC_ANALYTICS_DEBUG=true locally to inspect event payloads
   *   and provider routing in logger output.
   * - Keep disabled in normal development to reduce noise.
   */
  isAnalyticsDebugEnabled: process.env['NEXT_PUBLIC_ANALYTICS_DEBUG'] === 'true',

  /**
   * True ONLY on Vercel production deployments.
   *
   * Why this is separate from NODE_ENV:
   * - Vercel Preview deployments also have NODE_ENV === 'production'
   * - NEXT_PUBLIC_VERCEL_ENV distinguishes 'production' from 'preview'
   * - Analytics fired on Preview would pollute production dashboards
   *
   * Behaviour by environment:
   *   Vercel Production    NEXT_PUBLIC_VERCEL_ENV = 'production'  → true
   *   Vercel Preview       NEXT_PUBLIC_VERCEL_ENV = 'preview'     → false
   *   Local development    NEXT_PUBLIC_VERCEL_ENV = undefined      → false (NODE_ENV fallback)
   *   Non-Vercel production NEXT_PUBLIC_VERCEL_ENV = undefined     → true  (NODE_ENV fallback)
   */
  isProductionAnalytics:
    process.env['NEXT_PUBLIC_VERCEL_ENV'] !== undefined
      ? process.env['NEXT_PUBLIC_VERCEL_ENV'] === 'production'
      : process.env['NODE_ENV'] === 'production',
} as const;
